import "../../shared/styles/index.css";

const Placement_Highlight = () => {
  return (
    <div className="placement-container">
      <p className="placement-container-heading">CDGI Placement Highlights</p>

      <div className="placement-container-box">
        <div className="placement-each-conatiner">
          <p>100+</p>
          <p>Companies on Campus</p>
        </div>

        <div className="placement-each-container-line"></div>
        <div className="placement-each-conatiner">
          <p>12LPA</p>
          <p>Highest Package</p>
        </div>

        <div className="placement-each-container-line"></div>

        <div className="placement-each-conatiner">
          <p>4000 +</p>
          <p>Companies on Campus</p>
        </div>

        <div className="placement-each-container-line"></div>
        <div className="placement-each-conatiner">
          <p>18</p>
          <p>Years Of Academic Legacy</p>
        </div>
      </div>
    </div>
  );
};

export default Placement_Highlight;
